import Event from "./event";
import "./event_actions";
(function() {
    if ($("#create-new-event").length || $(".event-control-session-edit").length || $("#button-services-create-container").length) {

        let event = new Event("create-new-event");
        event.init();
    }
})(jQuery);